import { InvoiceStatus } from "src/app/domains/invoice";

/**
 * Règle unique « facture en retard » : facture envoyée (SENT) dont l'échéance est passée.
 * Les brouillons, validées non envoyées, payées ou annulées ne sont jamais en retard.
 * L'échéance du jour n'est pas encore en retard (comparaison au début de la journée).
 */
export function isInvoiceOverdue(
  invoice: { status?: string; payment_deadline?: string | Date | null },
  now: Date = new Date(),
): boolean {
  if (invoice?.status !== InvoiceStatus.SENT || !invoice.payment_deadline) return false;
  const startOfToday = new Date(now);
  startOfToday.setHours(0, 0, 0, 0);
  return new Date(invoice.payment_deadline) < startOfToday;
}
